import Vue from 'vue'
import {mapGetters, mapActions} from 'vuex'

import AppLogos from 'js/components/layout-footer/_app-logos.js'
import ContactMixin from 'js/mixins/contact-modal-mixin'
import AddressInfo from 'js/components/address-info/index.js'
import PhoneNumber from 'js/components/phone-number/index.js'
import ComplaintsBook from 'js/components/complaints-book/index.js'
import RouterLinkWrapper from 'js/components/router-link-wrapper/index.js'
import FollowUs from 'js/components/follow-us/index.js'

import template from './index.pug'

Vue.component('layout-footer', {
  name: 'layout-footer-custom-rd',
  template: template(),

  components: {
    AppLogos,
    AddressInfo,
    PhoneNumber,
    ComplaintsBook,
    FollowUs,
    RouterLinkWrapper
  },

  mixins: [ContactMixin],

  computed: {
    
    params() {
      if (!this.currentMunicipality) { return {country: 'rd'} }

      return {
        country: 'rd',
        municipality: this.currentMunicipality.name_normalized
      }
    }
  },

  methods: {
    goToPdf() {
      window.open(
        'https://samoverickpro.blob.core.windows.net/static-files/files/vz/Rodoamarante_C21' +
        '%20-%20Autocarros%20Limpos%20-%20Ficha%20para%20Publicita%C3%A7%C3%A3o.pdf',
        '_blank', 'noopener'
      )
    }
  }
})
